module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-collapse-item', {
    attrs: {
      "title": _vm.title
    }
  }, [_vm._l((_vm.descList), function(desc) {
    return _c('div', {
      key: desc,
      staticClass: "collapseDesc"
    }, [_vm._v(_vm._s(desc))])
  }), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1764b49b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CollapseInfo/collapseItem.vue
// module id = 1703
// module chunks = 1